import { render, staticRenderFns } from "./ToolsSidebar.vue?vue&type=template&id=6ee70d17&scoped=true"
import script from "./ToolsSidebar.vue?vue&type=script&lang=js"
export * from "./ToolsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToolsSidebar.vue?vue&type=style&index=0&id=6ee70d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee70d17",
  null
  
)

export default component.exports